import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const PreRegistrationPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    position: '',
    interest: '',
    custom_interest: ''
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const interestOptions = [
    'Sou empresário e quero aprender sobre blindagem com criptos',
    'Sou advogado e quero aprender a advogar com criptos',
    'Sou operador de criptomoedas e quero aperfeiçoar minha operação',
    'Quero implementar o KYC na minha empresa',
    'Outro (especificar)'
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/preregistration`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setSubmitted(true);
        // Reset form
        setFormData({
          name: '', email: '', phone: '', company: '', position: '', interest: '', custom_interest: ''
        });
      } else {
        throw new Error('Erro ao processar pré-matrícula');
      }
    } catch (error) {
      alert('Erro ao enviar pré-matrícula. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div style={{
        background: 'var(--gradient-primary)',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem'
      }}>
        <div className="glass-card" style={{
          padding: '4rem 3rem',
          textAlign: 'center',
          maxWidth: '600px',
          width: '100%'
        }}>
          <div style={{ fontSize: '4rem', marginBottom: '2rem' }}>🎉</div>
          <h1 style={{ color: 'var(--neon-green)', marginBottom: '1rem' }}>
            Pré-matrícula Realizada com Sucesso!
          </h1>
          <p style={{ fontSize: '1.2rem', opacity: 0.9, marginBottom: '2rem', lineHeight: '1.6' }}>
            Obrigado pelo seu interesse no curso <strong>Habeas Cripto</strong>!
            <br />
            Em breve entraremos em contato com mais informações.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button 
              className="btn-primary"
              onClick={() => navigate('/')}
              style={{ padding: '1rem 2rem' }}
            >
              🏠 Voltar ao Início
            </button>
            <button 
              className="btn-ghost"
              onClick={() => {
                setSubmitted(false);
                setFormData({
                  name: '', email: '', phone: '', company: '', position: '', interest: '', custom_interest: ''
                });
              }}
              style={{ padding: '1rem 2rem' }}
            >
              📝 Nova Pré-matrícula
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      background: 'var(--gradient-primary)',
      minHeight: '100vh',
      padding: '2rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div style={{ width: '100%', maxWidth: '700px' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <button 
            onClick={() => navigate('/')}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--neon-green)',
              fontSize: '2rem',
              cursor: 'pointer',
              marginBottom: '2rem',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              margin: '0 auto 2rem'
            }}
          >
            ← Habeas Cripto
          </button>
          <h1 style={{ color: 'white', fontSize: '2.5rem', marginBottom: '1rem' }}>
            Pré-matrícula do Curso
          </h1>
          <p style={{ color: 'white', opacity: 0.9, fontSize: '1.2rem' }}>
            Domine o Direito na Blockchain
          </p>
        </div>

        {/* Form */}
        <div className="glass-card" style={{
          padding: '3rem',
          background: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.2)'
        }}>
          <h2 style={{ color: 'var(--cyber-blue)', marginBottom: '2rem', textAlign: 'center' }}>
            📋 Formulário de Pré-matrícula
          </h2>
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Nome Completo *</label>
              <input
                type="text"
                className="form-input"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                required
                placeholder="Seu nome completo"
                style={{
                  background: 'rgba(255, 255, 255, 0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  color: 'white',
                  padding: '1rem',
                  borderRadius: '8px',
                  width: '100%',
                  fontSize: '1rem'
                }}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Email *</label>
              <input
                type="email"
                className="form-input"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                required
                placeholder="seu@email.com"
                style={{
                  background: 'rgba(255, 255, 255, 0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  color: 'white',
                  padding: '1rem',
                  borderRadius: '8px',
                  width: '100%',
                  fontSize: '1rem'
                }}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Telefone/WhatsApp *</label>
              <input
                type="tel"
                className="form-input"
                value={formData.phone}
                onChange={(e) => setFormData({...formData, phone: e.target.value})}
                required
                placeholder="(xx) xxxxx-xxxx"
                style={{
                  background: 'rgba(255, 255, 255, 0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  color: 'white',
                  padding: '1rem',
                  borderRadius: '8px',
                  width: '100%',
                  fontSize: '1rem'
                }}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Empresa/Organização</label>
              <input
                type="text"
                className="form-input"
                value={formData.company}
                onChange={(e) => setFormData({...formData, company: e.target.value})}
                placeholder="Nome da sua empresa (opcional)"
                style={{
                  background: 'rgba(255, 255, 255, 0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  color: 'white',
                  padding: '1rem',
                  borderRadius: '8px',
                  width: '100%',
                  fontSize: '1rem'
                }}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Cargo/Função</label>
              <input
                type="text"
                className="form-input"
                value={formData.position}
                onChange={(e) => setFormData({...formData, position: e.target.value})}
                placeholder="Seu cargo ou função (opcional)"
                style={{
                  background: 'rgba(255, 255, 255, 0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  color: 'white',
                  padding: '1rem',
                  borderRadius: '8px',
                  width: '100%',
                  fontSize: '1rem'
                }}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Principal interesse *</label>
              <select
                className="form-input"
                value={formData.interest}
                onChange={(e) => setFormData({...formData, interest: e.target.value})}
                required
                style={{
                  background: 'rgba(255, 255, 255, 0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  color: 'white',
                  padding: '1rem',
                  borderRadius: '8px',
                  width: '100%',
                  fontSize: '1rem',
                  cursor: 'pointer'
                }}
              >
                <option value="" style={{ background: 'var(--dark-slate)', color: 'white' }}>
                  Selecione uma opção
                </option>
                {interestOptions.map((option, index) => (
                  <option key={index} value={option} style={{ background: 'var(--dark-slate)', color: 'white' }}>
                    {option}
                  </option>
                ))}
              </select>
            </div>

            {formData.interest === 'Outro (especificar)' && (
              <div className="form-group">
                <label className="form-label">Especifique seu interesse *</label>
                <textarea
                  className="form-input"
                  rows="4"
                  value={formData.custom_interest}
                  onChange={(e) => setFormData({...formData, custom_interest: e.target.value})}
                  placeholder="Descreva seu interesse específico..."
                  required
                  style={{
                    background: 'rgba(255, 255, 255, 0.1)',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                    color: 'white',
                    padding: '1rem',
                    borderRadius: '8px',
                    width: '100%',
                    fontSize: '1rem',
                    resize: 'vertical',
                    minHeight: '120px'
                  }}
                />
              </div>
            )}

            <button 
              type="submit" 
              className="btn-primary" 
              disabled={loading}
              style={{
                width: '100%',
                padding: '1.25rem',
                fontSize: '1.2rem',
                fontWeight: 'bold',
                background: loading ? 'rgba(0, 255, 136, 0.5)' : 'var(--neon-green)',
                cursor: loading ? 'not-allowed' : 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.5rem'
              }}
            >
              {loading ? (
                <>
                  <div className="loading-spinner" style={{
                    width: '20px',
                    height: '20px',
                    border: '2px solid rgba(255,255,255,0.3)',
                    borderTop: '2px solid white',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                  }}></div>
                  Enviando...
                </>
              ) : (
                <>🚀 Confirmar Pré-matrícula</>
              )}
            </button>
          </form>

          <p style={{ fontSize: '0.9rem', opacity: 0.7, textAlign: 'center', marginTop: '2rem' }}>
            * Campos obrigatórios
          </p>
        </div>
      </div>

      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        .form-group {
          margin-bottom: 1.5rem;
        }
        
        .form-label {
          display: block;
          color: var(--cyber-blue);
          font-weight: 600;
          margin-bottom: 0.5rem;
          font-size: 1rem;
        }
        
        .form-input:focus {
          outline: none;
          border-color: var(--neon-green);
          box-shadow: 0 0 0 2px rgba(0, 255, 136, 0.2);
        }
        
        .form-input::placeholder {
          color: rgba(255, 255, 255, 0.5);
        }
      `}</style>
    </div>
  );
};

export default PreRegistrationPage;